import { Badge } from "./ui";
import { useT } from "@/i18n";
import type { CertificateStatus } from "@/lib/mock";

export function StatusBadge({ status }: { status: CertificateStatus }) {
  const { t } = useT();
  const mapping: Record<CertificateStatus, { tone: Parameters<typeof Badge>[0]["tone"]; label: string }> = {
    active: { tone: "green", label: t("status.active") },
    expiring: { tone: "amber", label: t("status.expiring") },
    expired: { tone: "red", label: t("status.expired") },
    pending: { tone: "brand", label: t("status.pending") },
    revoked: { tone: "slate", label: t("status.revoked") },
  };
  const { tone, label } = mapping[status];
  return (
    <Badge tone={tone} dot>
      {label}
    </Badge>
  );
}
